import { render, staticRenderFns } from "./organization-entities-view.vue?vue&type=template&id=84c89a84&scoped=true"
import script from "./organization-entities-view.vue?vue&type=script&lang=js"
export * from "./organization-entities-view.vue?vue&type=script&lang=js"
import style0 from "./organization-entities-view.vue?vue&type=style&index=0&id=84c89a84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c89a84",
  null
  
)

export default component.exports